export const INFORMED_HOME_PATH = '/'
export const INFORMED_IA_ENTRY = 'ia'

function stripEnvQuotes(value) {
  return String(value || '')
    .replace(/^['"]|['"]$/g, '')
    .trim()
}

export function getExternalContentEntryHosts(env = process.env) {
  return [env.REACT_APP_AI_ASSISTANT_URL, env.REACT_APP_BULLETIN_URL, env.REACT_APP_PAYWALL_URL]
    .map(stripEnvQuotes)
    .filter(Boolean)
}

function normalizeFromValue(value) {
  return String(value || '').toLowerCase()
}

export function isFromInformedIA(search, locationState) {
  const params = new URLSearchParams(String(search || '').replace(/^\?/, ''))
  const queryFrom = normalizeFromValue(params.get('from') || params.get('origem'))
  if (queryFrom === INFORMED_IA_ENTRY || queryFrom === 'ai') {
    return true
  }

  const stateFrom = normalizeFromValue(
    locationState && (locationState.from || locationState.origem)
  )
  return stateFrom === INFORMED_IA_ENTRY || stateFrom === 'ai'
}

export function isExternalContentReferrer(referrer, hosts = getExternalContentEntryHosts()) {
  if (!referrer) return false

  return hosts.some((host) => {
    const needle = host.replace(/^https?:\/\//, '').replace(/\/$/, '')
    return Boolean(needle) && referrer.indexOf(needle) !== -1
  })
}

export function shouldNavigateToInformedHome({
  referrer = '',
  historyLength = 1,
  search = '',
  locationState,
} = {}) {
  if (isFromInformedIA(search, locationState)) return true
  if (isExternalContentReferrer(referrer)) return true
  if (!historyLength || historyLength <= 1) return true
  return false
}

export function goToInformedHome(history) {
  if (!history || !history.push) return
  if (history.location && history.location.pathname === INFORMED_HOME_PATH) return
  history.push(INFORMED_HOME_PATH)
}

export function goBackFromContent(history, extras = {}) {
  if (!history) return

  const location = history.location || {}
  const referrer =
    extras.referrer !== undefined
      ? extras.referrer
      : typeof document !== 'undefined'
        ? document.referrer
        : ''
  const historyLength =
    extras.historyLength !== undefined
      ? extras.historyLength
      : typeof window !== 'undefined'
        ? window.history.length
        : history.length || 1

  if (
    shouldNavigateToInformedHome({
      referrer,
      historyLength,
      search: location.search,
      locationState: location.state,
    })
  ) {
    if (history.replace) {
      history.replace(INFORMED_HOME_PATH)
    }
    return
  }

  history.goBack()
}
